import { SidebarMenuMain } from './SidebarMenuMain'
import { checkedshowAdminPagesState, UncheckedshowAdminPagesState } from '../../../../../common/GlobalSlice'
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks'
import { useLocation, useNavigate } from 'react-router-dom';
import { t } from 'i18next';
import i18n from '../../../../../i18n/config';
import { useTranslation } from 'react-i18next';
import { getValueFromResource } from '../../../../../common/timeLiveFunction';
import { useEffect } from 'react';
const SidebarMenu = () => {
  const disptach = useAppDispatch();
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const licenseExpireFlag = localStorage.getItem("IsLicenseExpired");
  const IsFreeLicenseExpired = localStorage.getItem("IsFreeLicenseExpired");
  const expireFalg = (licenseExpireFlag === "true" || IsFreeLicenseExpired === "true");
  const systemCategoryPageFrontEnd = localStorage.getItem("systemCategoryPageFrontEnd");

  // const handleclick = () => {
  //   disptach(UncheckedshowAdminPagesState());
  //   if(expireFalg){
  //     navigate('/expiry');
  //   }else{
  //     navigate('/timesheet');
  //   }
  // }

  const { showAdminPages, menuList, showSubMenus } = useAppSelector((state) => state.globalState);
  const location = useLocation();
  const routeName = location.pathname.split('/').filter(Boolean)[0];
  const foundItem = menuList.filter(item => item.SystemCategoryPageFrontEnd != null && item.SystemCategoryPageFrontEnd.toLowerCase() === routeName.toLowerCase())[0];
  //    useEffect(() => {
  //   if (foundItem) {
  //     if (foundItem.SystemSecurityCategoryPageSectionId >= 1 && foundItem.SystemSecurityCategoryPageSectionId <= 13) {
  //       disptach(checkedshowAdminPagesState());
  //     } else {
  //       disptach(UncheckedshowAdminPagesState());
  //     }
  //   }
  // }, [foundItem, disptach]);

  const handleclick = () => {
    disptach(UncheckedshowAdminPagesState());

    if (expireFalg) {
      navigate('/expiry');
    } else {
      const safePage = systemCategoryPageFrontEnd?.trim();

      if (safePage && safePage !== 'null' && safePage !== 'undefined') {
        navigate(`/${safePage}`);
      } else {
        navigate('/dashboard');
      }
    }
  }


  return (
    <div className='app-sidebar-menu overflow-hidden flex-column-fluid'>
      {(!showSubMenus && showAdminPages || (routeName === 'manageterminology' && foundItem != undefined)) && <>
        <div className='menu-item' style={{ margin: '8px 24px 8px 6px' }} >
          <div className='menu-content pt-1 pb-2'>
            <span className='menu-section text-muted fs-6 cursor-pointer' onClick={handleclick}>
              <span className="bi bi-arrow-left fs-4 me-2"></span>
              {getValueFromResource('Back to Workspace', disptach, t)}</span>
          </div>
        </div>
      </>
      }
      <div
        id='kt_app_sidebar_menu_wrapper'
        className='app-sidebar-wrapper hover-scroll-overlay-y my-5'
        data-kt-scroll='true'
        data-kt-scroll-activate='true'
        data-kt-scroll-height='auto'
        data-kt-scroll-dependencies='#kt_app_sidebar_logo, #kt_app_sidebar_footer'
        data-kt-scroll-wrappers='#kt_app_sidebar_menu'
        data-kt-scroll-offset='5px'
        data-kt-scroll-save-state='true'
      >
        <div
          className='menu menu-column menu-rounded menu-sub-indention px-3'
          id='#kt_app_sidebar_menu'
          data-kt-menu='true'
          data-kt-menu-expand='false'
          style={{
            overflowY: 'auto',
            maxHeight: `calc(100vh - 150px)`,
            minHeight: '10px'
          }}
        >
          <SidebarMenuMain />
        </div>
      </div>
    </div>
  )
}

export { SidebarMenu }